import { placeInGroup, removeFromGroups } from './autoPlace';
import type { EditorTab } from './EditorTab';
import type { IProtoForm } from './IProtoForm';
import type { KeyToggle } from './KeyToggle';

/**
 * Перемикачі «Верх форми» і «Вкладки» редактора (прототип v4 feTop / feTabs): поле ключового рядка (статус поза ключовим рядком — у
 * «Подробицях»), теги під заголовком (інакше — у «Подробицях»), опис під заголовком (інакше — у «Нотатках»), вкладка. Чисті функції.
 */
export const topEdits = {
  key: (form: IProtoForm, k: KeyToggle): IProtoForm => {
    const on = !form.key[k];
    const next = { ...form, key: { ...form.key, [k]: on } };
    if (k !== 'status') return next;
    return on ? removeFromGroups(next, 'status') : placeInGroup(next, 'status', 'Details');
  },
  tags: (form: IProtoForm, tagsKey: string): IProtoForm => {
    const next = { ...form, showTags: !form.showTags };
    return next.showTags ? removeFromGroups(next, tagsKey) : placeInGroup(next, tagsKey, 'Details');
  },
  description: (form: IProtoForm): IProtoForm => {
    const next = { ...form, showDesc: !form.showDesc };
    return next.showDesc ? removeFromGroups(next, 'description') : placeInGroup(next, 'description', 'Notes');
  },
  tab: (form: IProtoForm, tab: EditorTab): IProtoForm => ({ ...form, tabs: { ...form.tabs, [tab]: !form.tabs[tab] } }),
};
